import { Link } from "react-router-dom";
import type { GossipCategory } from "@/mocks/gossipData";

interface CategoryCardProps {
  category: GossipCategory;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/gossip?category=${category.slug}`}
      className="group flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-400 hover:bg-accent-50 cursor-pointer"
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
        <i className={`${category.icon} text-2xl`} aria-hidden="true" />
      </span>
      <h3 className="font-heading text-xl text-foreground-950">{category.name}</h3>
      <p className="text-sm leading-relaxed text-foreground-600">{category.desc}</p>
      <span className="mt-1 flex items-center gap-1.5 text-xs font-label text-foreground-500">
        已收录 {category.count} 篇盘点
        <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
      </span>
    </Link>
  );
}